/**
* Created by lobin on 2020/7/31.
*/
<template>
	<div class="permission">
		<a-modal
			title="编辑权限"
			:visible="visible"
			:confirm-loading="submiting"
			@ok="handleOk"
			width="800px"
			@cancel="handleCancel"
		>
			<a-skeleton active v-if="loading"/>
			<a-row :gutter="20" v-else class="permission-list">
				<a-checkbox-group v-model="checked">
					<a-col :span="6" v-for="item in list" :key="item._id">
						<a-checkbox :value="item._id">{{ item.name }}({{ item.type }})</a-checkbox>
					</a-col>
				</a-checkbox-group>
			</a-row>
		</a-modal>
	</div>
</template>

<script type="text/babel">
import {
  updateRole,
  getResource,
} from '@/api/settings';

export default {
  data() {
    return {
      list: [],
	    checked: [],
	    visible: false,
      loading: false,
	    submiting: false,
		  id: '',
    };
  },
  created() {
  	this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const { data } = await getResource();
      this.list = data;
      this.loading = false;
    },
    show(id, permissions) {
    	this.id = id;
	    this.checked = permissions;
	    this.visible = true;
    },
	  async handleOk() {
    	this.submiting = true;
      const { data } = await updateRole(this.id, {
		    permissions: this.checked,
      });
      if (data) {
        this.$message.success('授权成功');
	      this.visible = false;
      }
	    this.submiting = false;
	  },
	  handleCancel() {
	    this.visible = false;
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.permission {
		&-list{
			.ant-col-6{
				line-height: 2.5;
			}
		}
	}
</style>
